<template>
  <v-chip
    :title="$t('tenants.upgrade_plan')"
    class="font-weight-regular"
    :to="{ name: 'tenant_settings' }"
    color="warning"
    link
    target="_blank"
    x-small
    >{{ _plan }}
  </v-chip>
</template>
<script>
export default {
  name: 'PlanChip',
  props: {
    plan: {
      type: String,
      required: false,
    },
  },
  computed: {
    _plan() {
      return this.plan || this.$nextPlan.name;
    },
  },
};
</script>
